
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm0 18.867c-1.443 0-2.753-1.445-3.575-3.63 1.126.236 2.333.36 3.575.36s2.45-.124 3.575-.36c-.822 2.185-2.131 3.63-3.575 3.63zm0-4.402a15.85 15.85 0 01-3.973-.492A15.903 15.903 0 017.536 12c0-1.418.178-2.77.49-3.974A15.903 15.903 0 0112 7.536c1.418 0 2.77.178 3.973.49.313 1.203.492 2.556.492 3.974 0 1.418-.178 2.77-.492 3.973a15.902 15.902 0 01-3.973.492zm-5.236-.89c-2.186-.822-3.63-2.132-3.63-3.575 0-1.444 1.444-2.753 3.63-3.575A17.467 17.467 0 006.402 12c0 1.242.125 2.45.362 3.575zM12 3.133c1.444 0 2.753 1.445 3.575 3.63A17.467 17.467 0 0012 6.404c-1.242 0-2.449.124-3.575.36.822-2.185 2.132-3.63 3.575-3.63zm5.236 5.292c2.186.822 3.63 2.131 3.63 3.575 0 1.443-1.444 2.753-3.63 3.575.237-1.126.362-2.333.362-3.575s-.125-2.45-.362-3.575zm3.043.401a8.193 8.193 0 00-1.342-.884 11.71 11.71 0 00-2.042-.837 11.717 11.717 0 00-.837-2.042 8.202 8.202 0 00-.884-1.342 8.914 8.914 0 015.105 5.105zM8.826 3.721a8.196 8.196 0 00-.883 1.342c-.33.62-.61 1.306-.838 2.042-.736.227-1.423.507-2.042.837-.507.27-.955.567-1.342.884a8.914 8.914 0 015.105-5.105zM3.721 15.174c.387.317.835.613 1.342.884.62.33 1.306.61 2.042.837.228.736.507 1.423.838 2.042.27.507.566.955.883 1.342a8.914 8.914 0 01-5.105-5.105zm11.453 5.105c.317-.387.613-.835.884-1.342.33-.62.61-1.306.837-2.042a11.71 11.71 0 002.042-.837c.507-.27.955-.567 1.342-.884a8.914 8.914 0 01-5.105 5.105z"}})])
          )
        }
      }
    